<!--
 Copyright (c) Qwoach LLC 2025. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 18/01/2025
-->

<template>

	<div class="register-screen-root qw-row justify-content-center my-5 py-5">
		<div>
			<div v-if="hasTeacher" class="mb-3 h3 text-center">
				<div>Join the {{className}} by {{teacherName}}</div>
			</div>
			<div class="bg-white shadow-7 p-5">
				<RegisterView
					:specialId="customPlanId"
					:requestCreditCardProp="!skipCreditCard"
					:actionButtonTextProp="actionText"
					:canShowNoCCMessage="canShowNoCCMessage"
					:userExtraProps="userExtraProps"
					:is-embedded="true"
					@accountCreated="onAccountCreated"
					class="register-view"
				/>
			</div>
		</div>

	</div>

</template>

<script>

import BaseComponent from "@/core/components/BaseComponent.vue";
import RegisterView from "@/core/modules/Login/RegisterView.vue";
import teacherMapObj from "@/core/modules/Login/TeacherMap";

export default {
	name: "RegisterScreen",
	components: {RegisterView},
	extends: BaseComponent,
	props:{
		teacherId: String,
	},

	data() {
		return {
			//https://qwoach.com/app/join/:teacherId
		}
	},

	methods: {
		async onAccountCreated() {
			await this.go("ClientListMainRoute")
		}
	},

	computed: {
		teacherData() {
			return this.teacherMap[this.teacherId] || {}
		},
		teacherName() {
			return this.teacherData.name || ""
		},
		className() {
			return this.teacherData.class || "class"
		},
		programName() {
			return this.teacherData.programName || "genogram"
		},
		teacherUid() {
			return this.teacherData.userId
		},
		hasTeacher() {
			return this.teacherMap[this.teacherId]
		},

		skipCreditCard(){
			return this.teacherData.access === "classPaid"
		},

		customPlanId() {
			if(this.teacherData.access === "freeTrial"){
				return "793798"
			}
			return null
		},

		canShowNoCCMessage() {
			return !this.hasTeacher
		},
		actionText() {
			return this.hasTeacher ? "Join Class" : null
		},
		userExtraProps() {
			let props = {}
			if(this.hasTeacher){
				props = {
					...props,
					teacherUid: this.teacherUid,
					teacherIdPublic: this.teacherId,
					programName: this.programName,
				}
			}
			return props
		},

		teacherMap(){
			return teacherMapObj
		},
	},
}
</script>

<style lang="scss">
@import "@/styles/responsive";
.register-screen-root{
	.register-view{
		width: 100%;
	}
	@include media-breakpoint-up(lg){
		.register-view{
			width: 600px
		}
	}
}

</style>
